import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.project.drawings');
import { OnInit, Input, Output, EventEmitter, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-component-project-drawings',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.project.drawings/view.scss */
:host {
  display: block;
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
}
.accordion-content.expanded {
  max-height: 2000px;
  transition: max-height 0.5s ease-in;
}`],
})
export class ComponentProjectDrawingsComponent implements OnInit {
    @Input() drawings: any[] = [];
    @Input() projectId: string = '';
    @Output() onAdd = new EventEmitter<void>();
    @Output() onDelete = new EventEmitter<any>();
    @Output() onDownload = new EventEmitter<any>();

    public isExpanded: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        if (this.drawings.length > 0) this.isExpanded = true;
    }

    public async toggleExpand() {
        this.isExpanded = !this.isExpanded;
        await this.service.render();
    }

    public openAddModal(event: Event) {
        event.stopPropagation();
        this.onAdd.emit();
    }

    public isPdf(drawing: any): boolean {
        const filepath = drawing?.filepath || drawing?.file_path || '';
        return filepath.toLowerCase().endsWith('.pdf');
    }

    public getFileName(drawing: any): string {
        return drawing?.filename || drawing?.filepath?.split('/').pop() || '제목 없음';
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        return dateStr.split(' ')[0];
    }

    public download(drawing: any) {
        this.onDownload.emit(drawing);
    }

    public async deleteItem(drawing: any) {
        const confirmed = await this.service.alert.show({
            title: '삭제 확인',
            message: '이 도면을 삭제하시겠습니까?',
            status: 'warning',
            action: '삭제',
            actionBtn: 'danger',
            cancel: '취소'
        });
        if (!confirmed) return;
        this.onDelete.emit(drawing);
    }
}

export default ComponentProjectDrawingsComponent;